import * as React from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {
  selectEmailDebugMode,
  selectUserContentSubscriptionExternal,
} from 'src/selectors/content-subscription';
import {saveUserSubscriptionExternalV2} from 'src/action-creators/content-subscription';
import ContentCategoryManagement from 'src/components/content-subscription/manage/content-category-management';


const ManageSubscriptions = (params: {
  trackingId?: string;
  unsubscribeCategoryId: string | null | undefined;
}) => {
  const [success, setSuccess] = React.useState(false);
  const dispatch = useDispatch();
  const userContentSubscriptionsFromStore = useSelector((state) => {
    if (params.trackingId) {
      return selectUserContentSubscriptionExternal(state, params.trackingId);
    }
    return [];
  });

  const attributeValue =
    userContentSubscriptionsFromStore[0]?.subscription?.[0].attribute_value;

  const isDebug = useSelector(selectEmailDebugMode);

  // storing the store's subscriptions data into local state
  // this will enable us to let users play with the subscription toggles
  // in the page and later when they save, we do a bulk update
  // discard button will just throw away this local state and fetch from store again
  const [userContentSubscriptionsLocal, setUserContentSubscriptionsLocal] =
    React.useState(userContentSubscriptionsFromStore);

  const onSubscriptionToggle = React.useCallback(
    // @ts-expect-error - TS7006 - Parameter 'categoryId' implicitly has an 'any' type. | TS7006 - Parameter 'checked' implicitly has an 'any' type.
    (categoryId, checked) => {
      const newLocalState = [...userContentSubscriptionsLocal];
      newLocalState.forEach((contentSubscription) => {
        if (
          contentSubscription.content_subscription_category_id === categoryId
        ) {
          contentSubscription.subscription[0].is_subscribed = checked;
        }
      });
      setUserContentSubscriptionsLocal(newLocalState);
    },
    [
      userContentSubscriptionsLocal,
      userContentSubscriptionsFromStore,
      setUserContentSubscriptionsLocal,
    ],
  );

  const onSave = async () => {
    try {
      await dispatch(
        saveUserSubscriptionExternalV2(
          userContentSubscriptionsLocal,
          params.trackingId ?? '',
        ),
      );
      setSuccess(true);
    } catch (e: any) {}
  };

  return (
    <ContentCategoryManagement
      onSave={onSave}
      onSubscriptionToggle={onSubscriptionToggle}
      isDebugEntity={isDebug}
      attributeValue={attributeValue}
      success={success}
      userContentSubscriptionsLocal={userContentSubscriptionsLocal}
    />
  );
};

export default ManageSubscriptions;
